import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import HealingIcon from "@mui/icons-material/Healing";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useMemo } from "react";
import { BUTTON_SX, HOST_STATUS } from "../../../lib/constants.js";

function getStatuses({ status }) {
  return {
    isDead: status === HOST_STATUS.DEAD,
    isHurt: status === HOST_STATUS.HURT,
    isOk: status === HOST_STATUS.OK,
  };
}

function StatusButton({ icon: Icon, disabled, onClick, label }) {
  return (
    <Button
      variant="outlined"
      color="secondary"
      disabled={disabled}
      onClick={onClick}
      size="large"
      endIcon={<Icon />}
      sx={BUTTON_SX.DISABLED}
    >
      {label}
    </Button>
  );
}

export default function DiagnosticsButtons({
  locales,
  status,
  handleStatusChange,
}) {
  const { isDead, isHurt, isOk } = useMemo(
    () => getStatuses({ status }),
    [status]
  );

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "row", md: "column" }}
      gap={{ xs: 2, smd: 4 }}
      justifyContent="center"
      id="maintenance-page-controls-diagnostics-buttons"
    >
      <StatusButton
        icon={HealthAndSafetyIcon}
        disabled={isOk}
        onClick={() => handleStatusChange(HOST_STATUS.OK)}
        label={locales["maintenance.diagnostics.repair"]}
      />
      <StatusButton
        icon={HealingIcon}
        disabled={isHurt}
        onClick={() => handleStatusChange(HOST_STATUS.HURT)}
        label={locales["maintenance.diagnostics.hurt"]}
      />
      <StatusButton
        icon={BrokenImageIcon}
        disabled={isDead}
        onClick={() => handleStatusChange(HOST_STATUS.DEAD)}
        label={locales["maintenance.diagnostics.dead"]}
      />
    </Box>
  );
}
